import type { ResubmitJobResultDto, ResubmitJobsResponseDto } from 'app/API/models';

export const parseBulkResubmitReport = (body: unknown, ids: string[]): ResubmitJobsResponseDto | null => {
  if (
    typeof body !== 'object' ||
    body === null ||
    !('totalFound' in body) ||
    body.totalFound !== ids.length ||
    !('results' in body) ||
    !Array.isArray(body.results)
  ) {
    return null;
  }
  const results: unknown[] = body.results;
  const parsedResults: ResubmitJobResultDto[] = [];
  const reportedIds = new Set<string>();
  for (const result of results) {
    if (
      typeof result !== 'object' ||
      result === null ||
      !('jobId' in result) ||
      typeof result.jobId !== 'string' ||
      !ids.includes(result.jobId) ||
      reportedIds.has(result.jobId) ||
      !('status' in result) ||
      (result.status !== 'resubmitted' && result.status !== 'error') ||
      ('error' in result && result.error !== undefined && typeof result.error !== 'string')
    ) {
      return null;
    }
    reportedIds.add(result.jobId);
    parsedResults.push({
      jobId: result.jobId,
      status: result.status,
      ...('error' in result && typeof result.error === 'string' ? { error: result.error } : {}),
    });
  }
  return { totalFound: ids.length, results: parsedResults };
};
